import * as css from './Money.css';
import {formatRealtimeNumber} from '../../../../functions';

export const Money = ({amount, currency}: { amount: number, currency: string }) => (
    <><css.currency>{currency}</css.currency>{formatRealtimeNumber(amount, true)}</>
);
